<template>
    <div id="questions">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/backStandard/topBg.jpg"/>
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>质疑/答疑</span></h2>
                    <p>质疑截止时间：{{ endTime }}</p>
                </div>
            </div>
        </div>
        <div class="main-container mainWrap">
            <section class="small-container uploadQ">
                <h2>
                    <img src="../../../assets/images/invitemanage/tit05.png"/>
                    <div style="float:right; width:300px;"  v-if="!!buttonShow">
                        <span class="tips" >上传附件大小不要超过500M</span>
                        <page-upload
                            v-show="isQuestionTime"
                            v-on:finishUpload="finishUploadFile"
                            :files="fileList"
                            :notMany="true"
                            :editFlag="true"
                            attachmentType=""
                            :limitType="2"
                            :notViewList="true"
                            :isIconTable="2">
                        </page-upload>
                    </div>
                </h2>
                <el-table
                    :data="extWFlowFormSuppliersQuestions"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        width="180"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        label="文件名称">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row,1)" title="点击下载">
                                {{ scope.row.attachName}}
                            </a>
                            <el-button type="text" size="" v-show="scope.row.isCanDel" class="delBtn" @click="fileListHandleRemove(scope.row,scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="questionTime"
                        label="质疑时间">
                    </el-table-column>
                </el-table>
                <div style="margin-top: 20px;" v-if="isQuestionTime && !!buttonShow">
                    <el-button class="cancelBtn" style="padding: 10px 40px;font-size: 14px;background: #cfcfcf;" @click="cancel">取消</el-button>
                    <el-button type="primary" style="padding: 10px 40px;font-size: 14px;" :disabled="isDisable" @click="submit" >提交</el-button>
                </div>
            </section>
            <section class="small-container">
                <h2 class="secondImg">
                    <img src="../../../assets/images/invitemanage/tit06.png"/>
                </h2>
                <el-table
                    :data="extSAttachments"
                    tooltip-effect="light"
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        label="序号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        :show-overflow-tooltip="true"
                        label="文件名称">
                        <template slot-scope="scope">
                            <a class="words" href="javascript:;" @click="fileListHandleDownload(scope.row,2)" title="点击下载">
                                {{ scope.row.attachName}}
                            </a>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="sendTime"
                        label="发出时间">
                    </el-table-column>
                    <el-table-column
                        prop="downTime"
                        label="下载时间">
                    </el-table-column>
                </el-table>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'questions',
        data() {
            return {
                formId: '',//路由跳转的id
                cancelId: '',//点击取消跳转的id;
                projectName: '',//项目名称
                endTime: '',
                extWFlowFormSuppliersQuestions: [],//质疑文件
                fileList: [],//上传文件的list
                uploadFileList: [],//新的需要提交的文件列表
                extSAttachments: [],//答疑补遗文件
                isQuestionTime: false,//是否过了质疑时间，true 是已过期
                isCanDel: false,//是否显示删除按钮；
                isDisable: false,
                buttonShow: false,
            }
        },
        created(){
            window.a = this;
            this.$root.activeIndex = 'win';
            this.getData(1);//初始化表格数据
        },
        methods: {
            getData(type){
                let that = this;
                this.$root.getHttp('/v1/outerformflow/askAndAnswer/list?formId='+this.$route.params.formId,function (res) {
                    if(res.data.data.dealBisVo.flowFormExtMng.flowFormStatus == '4'){
                        that.buttonShow = true;
                    }else{
                        that.buttonShow = false;
                    }
//                console.log(res)
                    that.extWFlowFormSuppliersQuestions = res.data.data.extWFlowFormSuppliersQuestions;//质疑文件
                    if(!that.extWFlowFormSuppliersQuestions.length) {
                        that.isDisable = true;
                    }
                    that.extWFlowFormSuppliersQuestions.forEach( (item,i) => {
                        item.isCanDel = false;
                    });
                    that.extSAttachments = res.data.data.extSAttachments;//答疑补遗文件
                    that.isQuestionTime = res.data.data.isQuestionTime;
                    that.projectName = res.data.data.dealBisVo.flowFormExtMng.formTitle;
                    that.endTime = res.data.data.questionsTime;
//                    that.endTime = res.data.data.questionsTime ? res.data.data.questionsTime.split(' ')[0] : '';
                    that.formId = res.data.data.dealBisVo.flowFormExtMng.flowFormId;
                    that.cancelId = res.data.data.dealBisVo.flowFormExtMng.id;
                    if(type == 1 && (!that.isQuestionTime) && that.buttonShow){
                        that.$alert('质疑截止时间已过，不能继续质疑！');
                    }
                })
            },
            finishUploadFile(val){//文件上传完成后，同步质疑文件数据；
//                console.log('同步',val)
                val.fileList.forEach( (item,i) => {
                    item.isCanDel = true;
                });
                this.uploadFileList = this.$root.concatArr(this.uploadFileList,val.fileList);
                this.extWFlowFormSuppliersQuestions = this.$root.concatArr(this.extWFlowFormSuppliersQuestions,this.uploadFileList);
                if(!this.extWFlowFormSuppliersQuestions.length) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            fileListHandleDownload(val,type) {
//                console.log(val, '下载')
                let that = this;
                that.$confirm('确定下载该附件吗?',{
                    type:'warning',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then( () => {
                    if(type == 1){
                        that.$root.downloadFile({
                            attachName: val.attachName,
                            attachPath: val.attachUrl || val.attachPath
                        });
                    } else {
                        that.$root.postHttp('v1/outerformflow/bidFile/down',{
                            formId: val.formId,
                            id: val.id,
                            type: val.attachmentType
                        },function (res) {
                            //code 1 成功了再进行下载
                            that.$root.downloadFile({
                                attachName: val.attachName,
                                attachPath: val.attachPath
                            });
                            that.getData(2);
                        });
                    }
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消下载'
                    })
                });
            },
            fileListHandleRemove(val,index){
//                console.log('序号',index)
                let that = this;
                that.$confirm('确定删除该附件吗?',{
                    type:'warning',
                    callback:(action)=>{
                        if(action == 'confirm'){
                            that.uploadFileList.splice(index,1);
                            that.uploadFileList = that.uploadFileList.filter( item => {
                                if(val.attachPath == item.attachPath && val.attachName == item.attachName ){
                                    return false;
                                }
                                return true;
                            });
                            that.extWFlowFormSuppliersQuestions.splice(index,1);
                            if(!that.extWFlowFormSuppliersQuestions.length) {
                                that.isDisable = true;
                            } else {
                                that.isDisable = false;
                            }
//                            console.log('删除',that.uploadFileList,that.extWFlowFormSuppliersQuestions)
                        }
                    }
                });
            },
            cancel(){//取消，跳转到
                this.$router.push('/master/processManagement/'+this.cancelId);
            },
            submit(){
//                console.log('提交');
                let that = this;
                if(!this.isQuestionTime){
                    that.$alert('当前已过质疑时间，不可再提交！', {
                        type: 'warning'
                    });
                    return;
                }
                if(this.fileList.length){
                    that.$confirm('提交后，不可删除已上传的质疑文件，是否继续?',{
                        type:'warning',
                        callback:(action)=>{
                            if(action == 'confirm'){
                                that.postSubmit();
                            }
                        }
                    });
                } else {
                    that.postSubmit();
                }
            },
            postSubmit(){
                let that = this;
                this.$root.postHttp('/v1/outerformflow/questions/submit',{
                    formId: this.$route.params.formId,
                    sattachments: this.uploadFileList,
                },function (res) {
                    /*  that.extWFlowFormSuppliersQuestions = res.data.data ? res.data.data.extWFlowFormSuppliersQuestions : [];
                         if(that.extWFlowFormSuppliersQuestions.length){
                              that.extWFlowFormSuppliersQuestions.forEach( (item) => {
                                  item.isCanDel = false;
                              })
                          }
                          that.getData();*/
                    that.$message.success('提交成功');
                    setTimeout( function(){
                        that.$router.push('/master/processManagement/'+that.formId);
                    },1500);
                },function(err){
                    that.isQuestionTime = false;
                })
            }
        }
    }
</script>
<style lang="scss">
@import "../../../assets/var";
#questions {
    padding-bottom: 50px;
    background: $--primary-fill-color;
    & .head-top{
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url('../../../assets/images/topBar2/icon07.png') no-repeat 0 1px;
        }
        & .register {
            background: url('../../../assets/images/topBar2/icon08.png') no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url('../../../assets/images/topBar2/icon05.png') no-repeat;
        }
        & .wechat {
            background: url('../../../assets/images/topBar2/icon06.png') no-repeat;
        }
    }
    .banner {
        margin-top: 80px;
        img {
            width: 100%;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        /*padding-bottom: 30px 0 60px;*/
    }
    .small-container {
        padding: 30px 70px 30px;
        background: #fff;
        margin-top: 30px;
        .secondImg img {
            width: 250px;
            height: 29px;
        }
        h2 {
            margin-top: 20px;
            overflow: hidden;
            img {
                float: left;
                width: 294px;
                height: 30px;
            }
            .el-button {
                float: right;
                padding: 6px 10px;
                height: 30px;
                i {
                    display: inline-block;
                    margin-right: 3px;
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                }
                .downloadIcon {
                    background: url('../../../assets/images/invitemanage/icon04.png') no-repeat;
                }
            }
        }
        .el-upload {
            float: right;
            .el-button {
                padding: 6px 20px;
                i {
                    height: 14px;
                }
            }
        }
        .el-table{
            margin-top: 20px;
            th {
              text-align: center;
            }
            td {
                text-align: center;
            }
            & .words {
                color: #333;
                text-decoration: none;
            }
            & .words:hover {
                color: $--primary-color;
                text-decoration: underline;
            }
        }
        .el-table::before {
            height: 0;
        }
    }
    .uploadQ .el-table {
        min-height: 200px;
        .delBtn {
            display: none;
            margin-left: 10px;
        }
        td {
            position: relative;
        }
        .el-table__body tr:hover > td .delBtn{
            display: inline-block;
            position: absolute;
            right: 0;
            top: 6px;
        }
        & .words {
            max-height: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #333;
            text-decoration: none;
        }
        & .words:hover {
            color: $--primary-color;
            text-decoration: underline;
        }
    }
    .uploadQ {
        .tips {
            float: left;
            margin-left: 20px;
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            line-height: 30px;
            color: #cb1235;
            background: url('../../../assets/images/register/icon03.png') no-repeat left center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/Questions.vue